import { useMediaPlayerContext } from "./context";
import { MediaChapter } from "./MediaChapter";

export interface MediaChaptersProps {
  playheadValue: number;
  pointerValue?: number;
}

export function MediaChapters({
  playheadValue,
  pointerValue = 0,
}: MediaChaptersProps) {
  const { chapters, duration } = useMediaPlayerContext();

  return (
    <div className="MediaChapters">
      {chapters?.map((chapter, index) => {
        const start = chapter.timestamp;
        const end =
          index === chapters.length - 1
            ? duration
            : chapters[index + 1].timestamp;

        return (
          <MediaChapter
            end={end}
            key={chapter.timestamp}
            playheadValue={playheadValue}
            pointerValue={pointerValue}
            start={start}
          />
        );
      })}
    </div>
  );
}
